import React from 'react';
import PropTypes from 'prop-types';
import GelLaneSelectImage from './img/gel-top.svg';
import {Image} from '@learningblocks/storybook-components';
import {
  EVENTS,
  RPM_UPDATE_RATE,
  TIME_UPDATE_RATE,
  FUNTION_CALL_INTERVAL,
  PULSE_TIME,
  formatView,
} from './GelLaneSelect.utils';

import {
  NOTIFY_EVENTS,
  getNewTime
} from '../Gelbox.utils';

export function GelLaneSelect(props) {
  // const [event, setEvent] = React.useState(null);
  //
  // const incrementRPM = () => props.setRPM(props.rpmValue + RPM_UPDATE_RATE);
  //
  // const decrementRPM = () => props.setRPM(props.rpmValue - RPM_UPDATE_RATE);
  //
  // const incrementTime = () => {
  //   const newTime = getNewTime(props.timeValue, TIME_UPDATE_RATE);
  //   props.setTimeValue(newTime);
  // };
  //
  // const decrementTime = () => {
  //   const newTime = getNewTime(props.timeValue, -1 * TIME_UPDATE_RATE);
  //   props.setTimeValue(newTime);
  // };
  //
  // if (event === EVENTS.INCREMENT_RPM) {
  //   setTimeout(incrementRPM, FUNTION_CALL_INTERVAL);
  // }
  //
  // if (event === EVENTS.DECREREMENT_RPM) {
  //   setTimeout(decrementRPM, FUNTION_CALL_INTERVAL);
  // }
  //
  // if (event === EVENTS.INCREMENT_TIME) {
  //   setTimeout(incrementTime, FUNTION_CALL_INTERVAL);
  // }
  //
  // if (event === EVENTS.DECREMENT_TIME) {
  //   setTimeout(decrementTime, FUNTION_CALL_INTERVAL);
  // }
  //
  // const onMouseDown = (eventType) => (event) => {
  //   setEvent(eventType);
  // };
  //
  // const onMouseUp = (event) => {
  //   setEvent(null);
  // };
  //
  // const setPulseTime = () => {
  //   if(props.balanced){
  //     props.setTimeValue(PULSE_TIME);
  //     props.runCentrifuge();
  //   } else {
  //     props.alert(NOTIFY_EVENTS.NOT_RUNNABLE);
  //   }
  // };
  //
  // const onClickStart = () => {
  //   props.runCentrifuge();
  // };

  const setGelActiveLane = (activeLane) =>{
    props.setGelActiveLane({
      id: 1,
      activeLane
    });
  }

  const getLanes = () => {

    let lanes = [];

    for(var lane in props.lanes){
      lanes.push({
        lane: lane.replace('lane', 'Lane '),
        contents: (props.lanes[lane].solutionAlias !== "")?props.lanes[lane].solutionAlias:"[Empty]"
      })
    }

    return (
      <>
        <div style={{
          display: "flex",
          flexDirection: "row",
          width: "calc(100% - 130px)",
          padding: "0 52px",
          top: "189px",
          position: "relative",
          margin: "0 auto"
        }}>
          {lanes.map((lane, index) => (
            <div style={{marginLeft: "4px", marginRight: "4px", width: "100%", display: "flex", flexDirection: "column"}}>
              <div style={{
                width: "40px",
                height: "40px",
                border: (lane.contents === "[Empty]")?"2px solid #FAAC48":"2px solid white",
                borderRadius: "40px",
                background: (lane.contents === "[Empty]")?((lane.lane.replace("Lane ", "lane") == props.selectedLane)?"#FAAC48":"white"):"transparent",
                cursor: (lane.contents === "[Empty]")?"pointer":"not-allowed",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 24px",
              }}
              onClick={(e)=>{
                if(lane.contents === "[Empty]"){
                  const selectedLane = lane.lane.replace("Lane ", "lane")
                  const selectedLaneNumber = lane.lane.replace("Lane ", "")
                  props.setSelectedLane(selectedLane)
                  setGelActiveLane(selectedLaneNumber)
                }
              }}
              >
              <b style={{
                color: (lane.contents === "[Empty]")?"black":"white"
              }}
              >{index + 1}</b></div>
              <div style={{
                width: "100%",
                height: "25px",
                borderLeft: "2px solid #7EA2B4",
                borderRight: "2px solid #7EA2B4",
                borderTop: "2px solid #5688a0",
                borderBottom: "2px solid #5688a0",
                boxSizing: "border-box",
                background: (lane.contents !== "[Empty]")?"#00AEEF":"#396477"
              }}></div>
            </div>
          ))}
        </div>
      </>
    );
  }

  return (
    <div className={props.className}>
      <div className={`${props.className}_lanes`}>
        {getLanes()}
      </div>
      <div className={`${props.className}_image`}>
        <Image
          src={GelLaneSelectImage}
          alt='Controls Panel'
          style={ (props.orientation === 360) ? {transform: 'rotate(180deg)'} : {}}
          className={`${props.className}_image_main`}
        />
      </div>
    </div>
  );
}

GelLaneSelect.propTypes = {
  /**
   * ClassName to set on component
   */
  className: PropTypes.string,
  /**
   * Current rpm value set
   */
  rpmValue: PropTypes.number,
  /**
   * Current Runtime set
   */
  timeValue: PropTypes.instanceOf(Date),
  /**
   * Time left for centrifuge to run to completion
   */
  timeLeft: PropTypes.instanceOf(Date),
  /**
   * Function to set RPM value
   */
  setRPM: PropTypes.func,
  /**
   * Function to set Run Time
   */
  setTimeValue: PropTypes.func,
  /**
   * Function to invoke when to  run the Centrifuge
   */
  runCentrifuge: PropTypes.func,
};

GelLaneSelect.defaultProps = {};
